import apiClient from '../../shared/api/apiClient'
import { ENDPOINTS } from '../../shared/api/endpoints'

export interface OrganizationProfile {
  id?: string
  name?: string
  schoolName?: string
  organizationName?: string
  orgName?: string
  title?: string
  email?: string
  primaryContactEmail?: string
  secondaryContactEmail?: string
  institutionalEmail?: string
  contactPhone?: string
  primaryContactPhone?: string
  secondaryContactPhone?: string
  phoneNumber?: string
  contactNumber?: string
  address?: string
  headOfficeAddress?: string
  physicalAddress?: string
  logoUrl?: string
  logo?: string
  logo_url?: string
  shortLivedLogoUrl?: string
  [key: string]: any
}

export const organizationApi = {
  /**
   * Get current organisation profile: GET /api/organization/me
   */
  async getMyOrganizationProfile(): Promise<OrganizationProfile> {
    try {
      const response = await apiClient.get<any>(ENDPOINTS.ORGANIZATION.ME)
      const raw = response.data?.data || response.data || {}
      const org = raw.organization || {}
      const branch = raw.branch || {}
      return {
        ...raw,
        id: raw.id || org.id,
        name: raw.orgName || raw.name || raw.schoolName || org.orgName || org.schoolName || branch.branchName,
        schoolName: raw.orgName || raw.schoolName || raw.name || org.orgName || org.schoolName || branch.branchName,
        orgName: raw.orgName || org.orgName || raw.schoolName || raw.name || branch.branchName,
        logoUrl: raw.logoUrl || raw.logo || org.logoUrl || branch.logoUrl,
        logo: raw.logo || raw.logoUrl || org.logoUrl || branch.logoUrl,
        headOfficeAddress: raw.headOfficeAddress || org.headOfficeAddress || raw.address,
        address: raw.headOfficeAddress || raw.address || org.headOfficeAddress || (typeof branch.address === 'string' ? branch.address : ''),
        email: raw.primaryContactEmail || raw.email || org.primaryContactEmail || branch.billingEmail,
        primaryContactEmail: raw.primaryContactEmail || org.primaryContactEmail || raw.email,
        secondaryContactEmail: raw.secondaryContactEmail || org.secondaryContactEmail,
        contactPhone: raw.primaryContactPhone || raw.contactPhone || org.primaryContactPhone || branch.contactNo,
        primaryContactPhone: raw.primaryContactPhone || org.primaryContactPhone || raw.contactPhone,
        secondaryContactPhone: raw.secondaryContactPhone || org.secondaryContactPhone,
      }
    } catch {
      try {
        const res = await apiClient.get<any>(ENDPOINTS.SETTINGS)
        const data = res.data?.data || res.data || {}
        return {
          ...data,
          logoUrl: data.logoUrl || data.logo || data.organization?.logoUrl || data.branch?.logoUrl || null,
        }
      } catch {
        return {}
      }
    }
  },
}
